import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { enumCompanyBusinessType } from '@app/data-layer/enums/companies';
import { CbpAssignedNumberRequestService } from '@services/cbp-assigned-number-request.service';
import { CompaniesService } from '@services/companies.service';
import { OrganizationsService } from '@services/organizations.service';
import { ReplaySubject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'company-cbp-assigned-number-request-start-page',
  templateUrl: './company-cbp-assigned-number-request-start-page.component.html',
  styleUrls: ['./company-cbp-assigned-number-request-start-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyCbpAssignedNumberRequestStartPageComponent implements OnInit, OnDestroy {
  public formGroup: UntypedFormGroup;
  public poaFileUrl: string = '';
  public requiredDocumentsListTexts: { [key: number]: string[] };
  public selectedRequiredDocumentsTextsArray: string[] = [];

  private destroy$: ReplaySubject<void> = new ReplaySubject<void>();

  constructor(
    private cbpAssignedNumberRequestService: CbpAssignedNumberRequestService,
    private companiesService: CompaniesService,
    private organizationsService: OrganizationsService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.formGroup = this.cbpAssignedNumberRequestService.getFormGroup();
    this.requiredDocumentsListTexts = this.cbpAssignedNumberRequestService.getRequiredDocumentsListTexts();
    this.setSelectedRequiredDocumentsTextsArray(this.formGroup.get('businessType').value);

    this.formGroup
      .get('businessType')
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe((businessType: enumCompanyBusinessType) => {
        this.setSelectedRequiredDocumentsTextsArray(businessType);
      });

    const companyId = this.companiesService.getCompany()?.id;
    if (companyId) {
      this.companiesService
        .getBrokerPoaFileUrl(companyId)
        .pipe(take(1))
        .subscribe((url: string) => {
          this.poaFileUrl = url;
          this.cdr.markForCheck();
        });
    } else {
      const organizationId = this.organizationsService.getOrganization()?.id;
      if (organizationId) {
        this.organizationsService
          .getBrokerPoaFileUrl(organizationId)
          .pipe(take(1))
          .subscribe((url: string) => {
            this.poaFileUrl = url;
            this.cdr.markForCheck();
          });
      }
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  public setSelectedRequiredDocumentsTextsArray(businessType: enumCompanyBusinessType) {
    this.selectedRequiredDocumentsTextsArray = this.requiredDocumentsListTexts[businessType];
  }
}
